import React from 'react'
import {
  TagSuccess,
  TagWarning,
  TagDanger,
} from '../components/ui_reusable/Tags'

export const SCORE_THRESHOLDS_FITNESS = {
  GOOD: 60,
  MODERATE: 30,
}

export const SCORE_THRESHOLDS_HEALTH = {
  GOOD: 70,
  MODERATE: 40,
}

export const SCORE_THRESHOLDS_QUALITY = {
  GOOD: 70,
  MODERATE: 40,
}

export type QualityString = 'good' | 'check' | 'fix'

export const QUALITY_MAPPING: Record<
  QualityString,
  { tag: React.JSX.Element; label: string }
> = {
  good: { tag: <TagSuccess label="good" />, label: 'good' },
  check: { tag: <TagWarning label="check" />, label: 'check' },
  fix: { tag: <TagDanger label="Fix" />, label: 'fix' },
}

// Score-based tag function
export const getFitnessTagByScore = (score: number): React.JSX.Element => {
  if (score >= SCORE_THRESHOLDS_FITNESS.GOOD) return <TagSuccess label="good" />
  if (score >= SCORE_THRESHOLDS_FITNESS.MODERATE)
    return <TagWarning label="moderate" />
  return <TagDanger label="Low" />
}

// Score-based tag function
export const getFitnessStringByScore = (score: number): string => {
  if (score >= SCORE_THRESHOLDS_FITNESS.GOOD) return 'good'
  if (score >= SCORE_THRESHOLDS_FITNESS.MODERATE) return 'moderate'
  return 'low'
}

// Score-based tag function
export const getHealthTagByScore = (score: number): React.JSX.Element => {
  if (score >= SCORE_THRESHOLDS_HEALTH.GOOD) return <TagSuccess label="good" />
  if (score >= SCORE_THRESHOLDS_HEALTH.MODERATE)
    return <TagWarning label="moderate" />
  return <TagDanger label="Low" />
}

// Score-based tag function
export const getHealthStringByScore = (score: number): string => {
  if (score >= SCORE_THRESHOLDS_HEALTH.GOOD) return 'good'
  if (score >= SCORE_THRESHOLDS_HEALTH.MODERATE) return 'moderate'
  return 'low'
}

// Score-based tag function
export const getQualityTagByScore = (score: number): React.JSX.Element => {
  if (score >= SCORE_THRESHOLDS_QUALITY.GOOD) return <TagSuccess label="good" />
  if (score >= SCORE_THRESHOLDS_QUALITY.MODERATE)
    return <TagWarning label="check" />
  return <TagDanger label="fix" />
}

// Score-based tag function
export const getQualityStringByScore = (score: number): string => {
  if (score >= SCORE_THRESHOLDS_QUALITY.GOOD) return 'good'
  if (score >= SCORE_THRESHOLDS_QUALITY.MODERATE) return 'check'
  return 'fix'
}

// Quality-based tag function
export const getQualityTagByQualityString = (
  quality: QualityString,
): React.JSX.Element => {
  return QUALITY_MAPPING[quality]?.tag || <TagDanger label="unknown" />
}
